import { IQuota } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';

type SetQuota = { type: 'SET_QUOTA'; payload: { userQuota: IQuota | undefined } };
type UpdateRemaingQuota = { type: 'UPADTE_REMAINING_QUOTA'; payload: { remaining: number | undefined; limit: number | undefined } };

export type QuotaAction = SetQuota | UpdateRemaingQuota;

export const setQuotaAction = (payload: { userQuota: IQuota | undefined }): SetQuota => ({ type: 'SET_QUOTA', payload });
export const updateRemaingQuotaAction = (payload: { remaining: number | undefined; limit: number | undefined }): UpdateRemaingQuota => ({ type: 'UPADTE_REMAINING_QUOTA', payload });
